import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from 'react-datepicker';

const TopCaseInfo = ({ rut, values, onChangeCommitmentDate }) => {
  const { createdAt, branchOffice, commitmentDate, new: newState, closedDate, editField } = values;
  const selectedCommitmentDate = commitmentDate ? new Date(commitmentDate) : null;

  return (
    <div className="crm-top-case-container">
      <div className="crm-top-case-info">
        {!rut && (
          <div>
            <h5 style={{ fontWeight: '600' }}>Creado</h5>
            <span>{moment(createdAt).format('DD/MM/YYYY, h:mm:ss')}
            </span>
          </div>
        )}
        {!newState && (
          <div>
            <h5 style={{ fontWeight: '600' }}>Sucursal</h5>
            <span>{branchOffice}</span>
          </div>
        )}
      </div>
      <div className="crm-top-case-info">
        {!newState && (
          <div>
            <h5 style={{ fontWeight: '600' }}>Fecha de compromiso</h5>
            {editField ? (
              <span>{commitmentDate ? moment(commitmentDate).format('DD/MM/YYYY, h:mm:ss') : 'Sin fecha'}</span>
            ) : (
              <DatePicker
                className="export-picker"
                selected={selectedCommitmentDate}
                onChange={onChangeCommitmentDate}
                showTimeSelect
                timeIntervals={15}
                timeCaption="Hora"
                dateFormat="dd/MM/yyyy, HH:mm:ss"
                placeholderText="Seleccione fecha"
              />
            )}
          </div>
        )}
        {!rut && (
          <div>
            <h5 style={{ fontWeight: '600' }}>Fecha de cierre</h5>
            <span>{(closedDate) ? moment(closedDate).format('DD/MM/YYYY, h:mm:ss') : 'Sin fecha'}</span>
          </div>
        )}
      </div>
    </div>
  );
};

TopCaseInfo.propTypes = {
  rut: PropTypes.string,
  onChangeCommitmentDate: PropTypes.func.isRequired,
  values: PropTypes.shape({
    createdAt: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    branchOffice: PropTypes.string,
    commitmentDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    new: PropTypes.bool,
    closedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    editField: PropTypes.bool,
  }).isRequired,
};

TopCaseInfo.defaultProps = {
  rut: '',
};

export default TopCaseInfo;
